export const languageMessages = (language:string, key: string) => {
    const messages: any = {
      en: {
        subject: 'Olé Life Evaluation',
        bodyHTML: 'Thank you for starting your application process for a Life Insurance with <b>Olé Life</b>.\nPlease select the most convenient day and time in the attached calendar to conduct a video interview, which is necessary to complete your evaluation.',
        titlePage: 'Your application has been <br/>successfully submitted!',
        subtitlePage: 'We are reviewing your application information and will contact you within the next 24 hours at',
        scheduleInterview: 'Schedule your evaluation video interview',
        scheduleExam: 'Schedule your medical exams',
        scheduleExamRecommendation: 'Remember that you must be fasting for 8 hours or more.',
        greeting: 'Hello ',
        whatsappLabel: 'WhatsApp Number',
        whenContact: 'When can we contact you?',
        timeContact: 'What time can we contact you?',
        selectPlaceholder: 'Select',
        availableDate: 'Available date',
        availableTime: 'Available time',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        scheduleButton: 'Schedule',
      },
      es: {
        subject: 'Olé Life Evaluación',
        bodyHTML: 'Gracias por iniciar su proceso de aplicación a un Seguro de Vida con <b>Olé Life</b>.\nFavor seleccionar en el calendario adjunto, el día y hora más convenientes para poder realizar una video entrevista, necesaria para concluir su evaluación.',
        titlePage: '¡Tu solicitud ha sido <br/>enviada con éxito!',
        subtitlePage: 'Estamos evaluando la información de tu solicitud y nos pondremos en contacto contigo dentro de las próximas 24 horas a',
        scheduleInterview: 'Agenda tu video entrevista de evaluación',
        scheduleExam: 'Agenda tus exámenes médicos',
        scheduleExamRecommendation: 'Recuerda que debes encontrarte en ayunas de 8 horas o más.',
        greeting: 'Hola ',
        whatsappLabel: 'Número de WhatsApp',
        whenContact: '¿Cuándo podemos contactarte?',
        timeContact: '¿A qué hora podemos contactarte?',
        selectPlaceholder: 'Seleccionar',
        availableDate: 'Fecha disponible',
        availableTime: 'Horario disponible',
        morning: 'Mañana',
        afternoon: 'Tarde',
        evening: 'Noche',
        scheduleButton: 'Agendar',
      },
      pt: {
        subject: 'Olé Life Avaliação',
        bodyHTML: 'Obrigado por iniciar seu processo de solicitação de um Seguro de Vida com <b>Olé Life</b>.\nPor favor, selecione o dia e horário mais conveniente no calendário anexado para realizar uma entrevista em vídeo, necessária para concluir sua avaliação.',
        titlePage: 'Sua solicitação foi <br/>enviada com sucesso!',
        subtitlePage: 'Estamos avaliando as informações da sua solicitação e entraremos em contato com você nas próximas 24 horas em',
        scheduleInterview: 'Agende sua entrevista de avaliação por vídeo',
        scheduleExam: 'Agende seus exames médicos',
        scheduleExamRecommendation: 'Lembre-se de que você deve estar em jejum por 8 horas ou mais.',
        greeting: 'Olá ',
        whatsappLabel: 'Número de WhatsApp',
        whenContact: 'Quando podemos entrar em contato?',
        timeContact: 'A que horas podemos entrar em contato?',
        selectPlaceholder: 'Selecionar',
        availableDate: 'Data disponível',
        availableTime: 'Horário disponível',
        morning: 'Manhã',
        afternoon: 'Tarde',
        evening: 'Noite',
        scheduleButton: 'Agendar',
      },
    }
    return messages[language][key];
  };